module.exports = __webpack_public_path__ + "img/jpg.b29c5dae.svg";